/**
 * Resolve the owning profile id for a resource request.
 * Backend payloads can vary, so check a few likely shapes.
 */
export function getRequestOwnerProfileId(request) {
  if (!request || typeof request !== "object") return "";

  const owner = request.owner;
  if (owner && typeof owner === "object") {
    const id = owner.profileId ?? owner.ProfileId ?? owner.id ?? owner.ownerId;
    if (id != null && String(id).trim() !== "") return String(id).trim();
  }
  if (typeof owner === "string" && owner.trim()) return owner.trim();

  const requester = request.requester;
  if (requester && typeof requester === "object") {
    const id =
      requester.profileId ??
      requester.ProfileId ??
      requester.id ??
      requester.requesterId;
    if (id != null && String(id).trim() !== "") return String(id).trim();
  }

  const flat =
    request.profileId ??
    request.ProfileId ??
    request.ownerProfileId ??
    request.OwnerProfileId ??
    request.requesterProfileId ??
    request.RequesterProfileId ??
    request.createdByProfileId ??
    request.CreatedByProfileId ??
    request.requestedByProfileId ??
    request.RequestedByProfileId ??
    request.ownerId ??
    request.OwnerId ??
    request.createdBy ??
    request.requestedBy;

  if (flat != null && String(flat).trim() !== "") return String(flat).trim();

  return "";
}

export function isRequestOwner(request, profileId) {
  if (!request || profileId == null || String(profileId).trim() === "") {
    return false;
  }
  const ownerId = getRequestOwnerProfileId(request);
  if (!ownerId) return false;
  return ownerId === String(profileId).trim();
}

export function canEditRequestForProfile(
  request,
  { profileId, tokenRole, tokenEntityType, isGuest } = {},
) {
  if (isGuest) return false;

  const entityType = String(tokenEntityType || "").trim().toLowerCase();
  if (entityType === "airport") return false;

  const role = String(tokenRole || "").trim().toLowerCase();
  if (role === "user") {
    return isRequestOwner(request, profileId);
  }

  return true;
}

export function getRequestEditDeniedMessage({
  tokenRole,
  tokenEntityType,
  isGuest,
} = {}) {
  if (isGuest) return "Guests cannot edit resource requests.";

  const entityType = String(tokenEntityType || "").trim().toLowerCase();
  if (entityType === "airport") {
    return "Airport Staff and Airport Admins cannot edit resource requests.";
  }

  const role = String(tokenRole || "").trim().toLowerCase();
  if (role === "user") {
    return "You can only edit resource requests you own.";
  }

  return "You do not have permission to edit this resource request.";
}
